const baseClass = 'get-estimate-widget';

const GetEstimateWidget = {
	init,
}


function createInstances() {
	const uninitialised = document.querySelectorAll(`.${baseClass}`);
	if (!uninitialised.length) {
		return;
	}

	uninitialised.forEach(widget => {
		const form = widget.querySelector('form');
		if (!form) {
			return;
		}

		form.setAttribute('novalidate', 'true'); // disable browser validation

		form.addEventListener('submit', (e) => {
			const invalidFields = validateForm(form);
			if (!invalidFields.length) {
				return; // form is valid, let it submit normally
			}

			e.preventDefault();

			// flag that the form should be validated
			form.classList.add('validate');

			form.addEventListener('change', (e) => {
				validateForm(form);
			});
		})

		initAddressField(form);
		initBedroomField(form);
		setContextMeta(form);
		setReferrerMeta(form);
	})
}

function initAddressField(form) {
	const input = form.querySelector('input[name="address"]');
	if (!input) {
		return;
	}

	input.addEventListener('change', (e) => {
		// reset hidden fields on change. Autocomplete sets their values
		// after this event fires.
		const latElem = form.querySelector('input[name="lat"]');
		const lngElem = form.querySelector('input[name="lon"]');
		latElem && (latElem.value = '');
		lngElem && (lngElem.value = '');
	});

	if (!isAutocompleteAvailable()) {
		return;
	}

	const autocomplete = new window.google.maps.places.Autocomplete(input, {
		fields: ['formatted_address', 'geometry', 'type', 'name'],
	});

	autocomplete.addListener('place_changed', () => {
		input.placesData = autocomplete.getPlace();
		const latElem = form.querySelector('input[name="lat"]');
		const lngElem = form.querySelector('input[name="lon"]');
		const shouldValidate = form.classList.contains('validate');

		if (!input.placesData || !input.placesData.geometry) {
			// reset hidden fields
			latElem && (latElem.value = '');
			lngElem && (lngElem.value = '');
			shouldValidate && validateForm(form);
			return;
		}

		const {geometry} = input.placesData;
		const lat = geometry.location.lat();
		const lng = geometry.location.lng();

		// store values in hidden fields
		latElem && (latElem.value = lat);
		lngElem && (lngElem.value = lng);

		shouldValidate && validateForm(form);
	})

}

function initBedroomField(form) {
	const input = form.querySelector('select[name="bedrooms"]');
	if (input) {
		const removePlaceholderOption = (e) => {
			if (input.value) {
				const placeholderOption = input.querySelector('option[value=""]');
				if (placeholderOption) {
					placeholderOption.remove();
					input.removeEventListener('change', removePlaceholderOption);
				}
			}
		}

		input.addEventListener('change', removePlaceholderOption);
	}
}

function setContextMeta(form) {
	const input = form.querySelector('input[name="context"]');
	if (!input) {
		return;
	}

	input.value = window.location.toString();
}

function setReferrerMeta(form) {
	const input = form.querySelector('input[name="referrer"]');
	if (!input) {
		return;
	}

	input.value = document.referrer;
}

function validateForm(form) {
	const fieldErrorClass = 'error';
	const lockupErrorClass = `${baseClass}__field-lockup--error`;

	const addErrorState = (field) => {
		field.classList.add(fieldErrorClass);
		const lockup = field.closest(`.${baseClass}__field-lockup`);
		lockup && lockup.classList.add(lockupErrorClass);
	}

	const removeErrorState = (field) => {
		field.classList.remove(fieldErrorClass);
		const lockup = field.closest(`.${baseClass}__field-lockup`);
		lockup && lockup.classList.remove(lockupErrorClass);
	}

	const invalidFields = [];
	const fields = [
		{
			name: 'address',
			element: form.querySelector('input[name="address"]'),
			isValid() {
				const formData = new FormData(form);
				const lat = formData.get('lat'); // check for geometry value
				const address = formData.get('address');
				return isAutocompleteAvailable()
					? address && lat
					: address;
			},
		},
		{
			name: 'bedrooms',
			element: form.querySelector('select[name="bedrooms"]'),
			isValid() {
				return !!this.element && !!this.element.value;
			},
		},
	];

	// validate fields
	fields.forEach(field => {
		const isValid = field.isValid();
		if (isValid) {
			removeErrorState(field.element);
		}
		else {
			invalidFields.push(field.element);
			addErrorState(field.element);
		}
	});

	// enable/disable submit button
	const submit = form.querySelector('button[type="submit"]');
	if (invalidFields.length && submit) {
		submit.setAttribute('disabled', 'true');
	}
	else if (!invalidFields.length && submit) {
		submit.removeAttribute('disabled');
	}

	return invalidFields;
}

function isAutocompleteAvailable() {
	try {
		return !!window.google.maps.places.Autocomplete;
	}
	catch (err) {
		return false;
	}
}

function init() {
	window.GR = window.GR || {};

	if (!window.GR.placesApiReady) {
		setupPlacesApi();
	}
	else {
		createInstances();
	}
}

function setupPlacesApi() {
	window.onPlacesApiReady = function() {
		window.GR.placesApiReady = true;
		createInstances();
	}

	const key = window.GRvars
		? window.GRvars.places_api
		: '';

	injectPlacesScriptTag(key, 'onPlacesApiReady');
}


function injectPlacesScriptTag(key, callbackName) {
	const elem = document.createElement('script');
	elem.type = 'text/javascript';
	elem.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places&callback=${callbackName}`;

	document.head.appendChild(elem);
}


export default GetEstimateWidget;



// WEBPACK FOOTER //
// ./scripts/modules/get-estimate-widget.js